/**
 * Notifications that imply workspace/project membership changed server-side.
 * Client workspace/project lists should refetch so navigation and switchers stay consistent.
 */
export function notificationRequiresWorkspaceRefresh(eventType: string): boolean {
  return (
    eventType === "workspaceMemberAddedEvent" ||
    eventType === "workspaceMemberRemovedEvent" ||
    eventType === "shareInviteAcceptedEvent"
  );
}
